






























































































import { subscriptionApi } from '../subscription.api';
import { Component } from 'vue-property-decorator';
import BaseTable from '@/modules/core/components/BaseTable';
import { PaginationResult } from '@shared/common/types';
import { Subscription } from '../subscription';

@Component
export default class SubscriptionsTable extends BaseTable {
  public async fetchData(): Promise<PaginationResult<Subscription>> {
    return await subscriptionApi.findAll({
      ...this.pagination,
      ...this.filters,
      sort: this.sort,
    });
  }
}
